import React from 'react'
import cx from 'classnames'
import Image from '../contentParticles/image'

class DataTable extends React.Component {
  renderTableRowCells = (index) => {
    const {
      columnAccent,
      dataByRow,
      dataByRowAlt,
      dataByRowLeft,
    } = this.props.content

    const row = dataByRow
      ? dataByRow[index]
      : dataByRowAlt
      ? dataByRowAlt[index]
      : dataByRowLeft
      ? dataByRowLeft[index]
      : null

    if (!row) {
      return
    }

    if (dataByRowLeft) {
      return row.map((data, index) => (
        <td
          data-label="datatable-cell"
          key={`data-cell-${index}`}
          className={cx(
            'pl-20 pr-10 text-9 sm:text-16 py-10 align-top text-left',
            {
              'bg-smoke-white': index + 1 === columnAccent,
              'w-1/3': index + 1 !== row.length,
              'w-1/2': index + 1 === row.length,
            }
          )}
          dangerouslySetInnerHTML={{ __html: data }}
        />
      ))
    }

    if (dataByRowAlt) {
      return row.map((data, index) => (
        <td
          data-label="datatable-cell"
          key={`data-cell-${index}`}
          className={cx('pl-20 pr-10 text-9 sm:text-16 py-10 align-top', {
            'bg-smoke-white': index + 1 === columnAccent,
            'text-right w-1/3': index + 1 !== row.length,
            'text-left w-1/2': index + 1 === row.length,
          })}
          dangerouslySetInnerHTML={{ __html: data }}
        />
      ))
    }

    return row.map((data, index) => (
      <td
        data-label="datatable-cell"
        key={`data-cell-${index}`}
        className={cx(
          'pl-20 pr-10 text-9 sm:text-16 text-right py-10 align-top',
          {
            'bg-smoke-white': index + 1 === columnAccent,
          }
        )}
        dangerouslySetInnerHTML={{ __html: data }}
      />
    ))
  }

  renderTableRows() {
    const { rowHeadings, rowAccent } = this.props.content

    if (!rowHeadings) {
      return null
    }

    return rowHeadings.map((heading, index) => {
      let hasImage = false
      let headingText = heading

      if (typeof heading !== 'string') {
        hasImage = true
        headingText = heading.text
      }

      return (
        <tr
          data-label="datatable-row"
          key={`table-row-${index}`}
          className={cx('border-b border-columbia-gray', {
            'bg-smoke-white': index + 1 === rowAccent,
          })}
        >
          {hasImage ? (
            <th
              scope="row"
              data-label="datatable-heading"
              className="text-left text-10 sm:text-14 font-normal py-10 pl-10 pr-40 flex items-center"
            >
              <span className="block w-90 mr-10 flex-shrink-0">
                <Image sdg images={heading.images} />
              </span>
              <span dangerouslySetInnerHTML={{ __html: headingText }} />
            </th>
          ) : (
            <th
              scope="row"
              data-label="datatable-heading"
              className="text-left text-10 sm:text-14 font-normal p-10"
              dangerouslySetInnerHTML={{ __html: headingText }}
            />
          )}
          {this.renderTableRowCells(index)}
        </tr>
      )
    })
  }

  renderTableColumnHeadings() {
    const { theme } = this.props
    const {
      columnAccent,
      columnHeadings,
      dataByRow,
      dataByRowAlt,
      dataByRowLeft,
    } = this.props.content

    if (!columnHeadings) {
      return null
    }

    const sampleRowData = dataByRow
      ? dataByRow[0]
      : dataByRowAlt
      ? dataByRowAlt[0]
      : dataByRowLeft
      ? dataByRowLeft[0]
      : null

    if (dataByRowLeft) {
      return columnHeadings.map((heading, index) => (
        <th
          data-label="datatable-column-heading"
          scope="col"
          className={cx(
            `font-condensed uppercase font-normal text-18 text-left pl-20 pr-10 ${theme.textColor}`,
            {
              'bg-smoke-white': index === columnAccent,
            }
          )}
          key={`colhead-${index}`}
          dangerouslySetInnerHTML={{
            __html: heading,
          }}
        />
      ))
    }

    if (dataByRowAlt) {
      return columnHeadings.map((heading, index) => (
        <th
          data-label="datatable-column-heading"
          scope="col"
          className={cx(
            `font-condensed uppercase font-normal text-18 ${theme.textColor}`,
            {
              'bg-smoke-white': index === columnAccent,
              'text-right pl-20 pr-10':
                (columnHeadings.length <= sampleRowData.length || index != 0) &&
                index + 1 !== columnHeadings.length,
              'text-left pl-20 pr-10':
                (columnHeadings.length > sampleRowData.length && index === 0) ||
                index + 1 === columnHeadings.length,
            }
          )}
          key={`colhead-${index}`}
          dangerouslySetInnerHTML={{
            __html: heading,
          }}
        />
      ))
    }

    return columnHeadings.map((heading, index) => (
      <th
        data-label="datatable-column-heading"
        scope="col"
        className={cx(
          `font-condensed uppercase font-normal text-18 ${theme.textColor}`,
          {
            'bg-smoke-white': index === columnAccent,
            'text-right pl-20 pr-10':
              columnHeadings.length <= sampleRowData.length || index != 0,
            'text-left pl-10 pr-20':
              columnHeadings.length > sampleRowData.length && index === 0,
          }
        )}
        key={`colhead-${index}`}
        dangerouslySetInnerHTML={{ __html: heading }}
      />
    ))
  }

  renderTable() {
    return (
      <table className="mb-32 w-full">
        <thead className="border-b border-columbia-gray">
          <tr>{this.renderTableColumnHeadings()}</tr>
        </thead>
        <tbody>{this.renderTableRows()}</tbody>
      </table>
    )
  }

  render() {
    return <div data-label="datatable">{this.renderTable()}</div>
  }
}

export default DataTable
